const tabifoto = {
  tabifoto: {
    nav: {
      home: "ホーム",
      booking: "予約する",
      philosophy: "私たちの想い",
      language: "言語",
      apply: "フォトグラファーになる",
    },
    hero: {
      headline_1: "旅の記憶を",
      headline_2: "日本で刻む",
      subheadline: "地元の独立フォトグラファーと繋がり、本物のストーリーを残しましょう",
      cta: "ストーリーを始める",
    },
    cities: {
      section_title: "目的地を選ぶ",
      section_sub: "都市を選んで、地元フォトグラファーを探してみましょう",
      kyoto: "京都",
      osaka: "大阪",
      tokyo: "東京",
      coming_soon: "近日公開",
    },
    storytelling: {
      label: "私たちの理念",
      quote: "写真とは場所ではなく、その間に生まれる瞬間のことです。",
      body: "すべての旅は、誠実に美しく残されるべきだと私たちは信じています。TaBiFoToは、日本の魂を知る地元の独立フォトグラファーとあなたを繋ぎます。",
    },
    services: {
      section_title: "サービス内容",
      section_sub: "純粋な写真撮影体験 — セット販売なし、余計なものなし",
      photography_8h: {
        title: "8時間フォトグラフィー",
        desc: "地元フォトグラファーと一日を過ごし、都市の中で本物の瞬間を捉えます。",
        feature_1: "8時間の専属撮影",
        feature_2: "100枚以上のレタッチ済みデジタル写真",
        feature_3: "プライベートオンラインギャラリー",
      },
      photography_video: {
        title: "フォトグラフィー＋ショートムービー",
        desc: "写真パッケージのすべてに加え、映画のような短編フィルムも。",
        feature_1: "写真パッケージのすべての特典",
        feature_2: "60〜90秒のシネマティック動画",
        feature_3: "サウンドトラック・カラーグレーディング込み",
      },
      from_price: "料金はお問い合わせください",
    },
    booking: {
      title: "フォトグラフィー体験を予約する",
      step_1: "都市を選ぶ",
      step_2: "サービスを選ぶ",
      step_3: "日付を選ぶ",
      step_4: "オプション",
      step_5: "予約確認",
      select_city: "あなたのストーリーはどこで始まりますか？",
      select_service: "体験プランを選んでください",
      select_date: "特別な日はいつですか？",
      select_addons: "オプション追加",
      addons_note: "以下は外部パートナーサービスです。TaBiFoToが提供するものではありません",
      kimono_title: "着物レンタル",
      kimono_desc: "伝統的な着物を着て撮影。地元の着物パートナーが手配します。",
      makeup_title: "ヘア＆メイク",
      makeup_desc: "撮影前のプロによるスタイリング。地元の美容パートナーが手配します。",
      external_partner: "外部パートナー",
      checkout_title: "ご予約の確認",
      your_name: "お名前",
      your_email: "メールアドレス",
      your_phone: "電話番号",
      special_requests: "特別なご要望（任意）",
      order_summary: "予約内容",
      city_label: "都市",
      service_label: "サービス",
      date_label: "日付",
      addons_label: "オプション",
      none: "なし",
      confirm_booking: "予約を確定する",
      booking_confirmed: "予約リクエストを受け付けました",
      booking_confirmed_desc: "リクエストを受け取りました。24時間以内にフォトグラファーをご確認いたします。",
      next: "次へ",
      back: "戻る",
      select_date_placeholder: "日付を選択",
      morning: "午前",
      afternoon: "午後",
      full_day: "終日",
      legal_loading: "規約を読み込み中...",
      legal_section_title: "利用規約の確認",
      legal_section_sub: "続行する前に以下の規約をお読みください",
      legal_agree_prefix: "同意する",
      legal_version_prefix: "バージョン",
      legal_effective_prefix: "発効日",
      legal_view_content: "規約を読む",
      legal_hide_content: "閉じる",
      legal_required: "必須",
      legal_optional: "任意",
      legal_all_required_msg: "必須の規約にすべて同意してください",
      legal_must_accept: "予約を完了するには必須の規約にすべて同意する必要があります",
      field_required: "必須",
      field_email_invalid: "有効なメールアドレスを入力してください",
      photographer_preference_label: "フォトグラファーの快適性希望（任意）",
      photographer_preference_none: "希望なし",
      photographer_preference_female_preferred: "女性フォトグラファーを希望",
      photographer_preference_note: "この希望はマッチングの参考としてのみ使用され、受注制限にはなりません。",
    },
    product: {
      photography_8h: "8時間フォトグラフィー",
      photography_video: "フォトグラフィー＋動画",
    },
    philosophy: {
      hero_title: "写真であり、パッケージではない",
      hero_sub: "私たちは、人と本物のストーリーテラーを繋ぐために存在しています。観光ツアーを売るためではありません。",
      section_1_title: "私たちについて",
      section_1_body: "TaBiFoToは、旅行者と日本各地の独立フォトグラファーを繋ぐ予約プラットフォームです。旅行代理店ではなく、ツアーや交通・宿泊を含むパッケージは一切販売しておりません。",
      section_2_title: "独立フォトグラファー",
      section_2_body: "プラットフォームのすべてのフォトグラファーは、独自の創造的ビジョン、地元の知識、プロのスキルを持つ独立契約者です。私たちはフォトグラファーを雇用するのではなく、その声を広げます。",
      section_3_title: "私たちが販売するもの",
      section_3_body: "私たちはフォトグラファーと過ごす時間を販売します。一つのスキル。一つの技術。誠実に美しく保存されます。アップセルなし、バンドルなし、曖昧さなし。",
      section_4_title: "モニュメントではなく、瞬間",
      section_4_body: "日本には象徴的な場所が無数にあります。本当に希少なのは、混雑した街の片隅に静かな光を見つけられる人です——それが私たちのフォトグラファーです。",
      values_title: "私たちの価値観",
      value_1_title: "真実性",
      value_1_body: "本物のフォトグラファー、本物の瞬間、本物の思い出。",
      value_2_title: "独立性",
      value_2_body: "すべてのフォトグラファーが自分の技術と創造的自由を持つ。",
      value_3_title: "シンプリシティ",
      value_3_body: "一つのサービス。写真撮影。美しく仕上げる。",
      cta_title: "思い出を作る準備はできましたか？",
      cta_body: "予約を始めて、最適なフォトグラファーをご紹介します。",
      cta_button: "フォトグラファーを予約",
    },
    footer: {
      tagline: "日本全国の本物の写真撮影体験",
      links_explore: "探索",
      link_home: "ホーム",
      link_booking: "予約する",
      link_philosophy: "私たちの想い",
      links_info: "情報",
      link_faq: "よくある質問",
      link_contact: "お問い合わせ",
      link_terms: "利用規約",
      link_apply: "フォトグラファーになる",
      newsletter_label: "インスピレーションを受け取る",
      newsletter_placeholder: "メールアドレス",
      newsletter_submit: "登録する",
      copyright: "© 2024 TaBiFoTo. All rights reserved.",
    },
    admin: {
      orders: "注文管理",
      photographers: "フォトグラファー管理",
      assignments: "アサイン管理",
    },
    apply: {
      page_title: "フォトグラファーになる",
      page_sub: "クローズドベータ募集中 · 日本各地の独立フォトグラファーを募集しています",
      philosophy_title: "私たちのコラボレーション理念",
      philosophy_body: "TaBiFoToは観光プラットフォームではありません——フォトグラファーと旅行者をつなぐ橋です。各フォトグラファーのクリエイティブな独立性を尊重し、予約・コミュニケーション・管理業務を担当します。あなたは撮影に集中できます。",
      philosophy_point_1: "フォトグラファーの完全なクリエイティブ自由",
      philosophy_point_2: "プラットフォームが予約・コミュニケーション・管理を担当",
      philosophy_point_3: "透明な収益分配、隠れた費用なし",
      requirements_title: "応募条件",
      req_language_title: "言語能力",
      req_language_body: "英語・中国語・日本語のいずれかでクライアントを対応できること（最低1言語）。流暢さよりコミュニケーション能力を重視します。",
      req_cities_title: "対応可能都市",
      req_cities_body: "現在対応都市：京都・大阪・東京。今後拡大予定です。",
      req_portfolio_title: "ポートフォリオ",
      req_portfolio_body: "ポートフォリオのリンクをご提供ください（Instagram・個人サイト・Behanceなど）。特定のスタイルは不問です——本物で温かみのある作品を求めています。",
      form_title: "応募フォーム",
      form_note: "クローズドベータ期間中は、申請内容を手動で審査します。採用が決まった場合、直接ご連絡します。",
      field_name: "氏名",
      field_name_placeholder: "お名前（フルネーム）",
      field_email: "メールアドレス",
      field_email_placeholder: "your@email.com",
      field_line_or_contact: "LINE / その他連絡先",
      field_line_or_contact_placeholder: "LINE IDまたはその他の連絡先",
      field_service_cities: "対応可能都市",
      field_languages: "対応可能言語",
      field_portfolio_url: "ポートフォリオURL",
      field_portfolio_url_placeholder: "https://instagram.com/...",
      field_profile_image_url: "プロフィール写真URL（任意）",
      field_profile_image_url_placeholder: "https://...",
      field_short_bio: "自己紹介",
      field_short_bio_placeholder: "あなたの撮影スタイルと経験を簡単にご紹介ください（200字以内）",
      city_kyoto: "京都",
      city_osaka: "大阪",
      city_tokyo: "東京",
      lang_zh: "中国語",
      lang_en: "英語",
      lang_ja: "日本語",
      submit: "応募する",
      submitting: "送信中...",
      success_title: "応募を受け付けました",
      success_body: "ご応募ありがとうございます！審査後、メールにてご連絡いたします。",
      error_required: "この項目は必須です",
      error_email: "有効なメールアドレスを入力してください",
      error_city: "少なくとも1つの都市を選択してください",
      error_language: "少なくとも1つの言語を選択してください",
      error_submit: "送信に失敗しました。もう一度お試しください。",
    },
  },
};

export default tabifoto;
